import { textCase } from "../ui/UI";
import CacheStorage from "../storage/CacheStorage";
import StorageKeys from "../../const/StorageKeys";

const AppTranslation = new (class AppTranslation {
  lang: string = "en";

  text = (key: string): string => {
    const languageSession: string =
      CacheStorage.getValue(StorageKeys.language) || this.lang;
    return textCase(translations[languageSession][key] ?? key);
  };
})();

const branchLabelEn: string = "branch",
  branchesLabelEn: string = "branches",
  branchLabelAr: string = "فرع",
  branchesLabelAr: string = "الفروع";

const translations: any = {
  en: {
    home: "home",
    email: "email",
    password: "password",
    login: "login",
    forgot_your_password: "forgot your password?",
    company_info: "company info",
    manage_teams: "manage teams",
    manage_groups: "manage groups",
    company_name: "company name",
    internal_display_page: "internal display name",
    landline_number: "landline number",
    mobile_number: "mobile number",
    company_website: "company website",
    information: "information",
    address: "address",
    title: "title",
    phone_number: "phone number",
    assign_admin: "assign admin",
    country: "country / region",
    state: "state",
    city_town: "city / town",
    suburb: "suburb",
    building_name: "building name",
    street_name: "street name",
    apartment_office_unit_no: "apartment, office or unit no.",
    add_team_member: "add team member",
    manage_chats: "manage chats",
    choose_team: "choose team",
    add_chats: "add chats",
    group_title: "group title",
    group_type: "group type",
    open: "open",
    restricted: "restricted",
    security_passcode: "security passcode",
    assign_team: "assign team",
    default_message: "default message",
    type_here_max_200_chars: "type here (max 2000 characters)",
    please_wait: "please wait...",
    search: "search",
    username: "username",
    no_results_found: "no results found",
    format_file_image: "format - jpeg, png\nmin. size - 50x50 px",
    format_file_image2: "format - jpeg, png min. size - 50x50 px",
    change: "change",
    manual_form: "manual form",
    create_temp_username_password: "create temp username / password",
    generate_link: "generate link",
    add_sub_admin: "add sub admin",
    edit_sub_admin: "edit sub admin",
    upload: "upload",
    first_name: "first name",
    last_name: "last name",
    position: "position",
    public_visibility: "public visibility",
    internal_chat_visibility: "internal chat visibility",
    manage_sub_admins: "manage sub admins",
    branch_search: `${branchLabelEn} search`,
    add_branch: "add branch",
    choose_city: "choose city",
    continue: "continue",
    update_branch: "update branch",
    location: "location",
    branch_info: `${branchLabelEn} info`,
    manage_branch_admin: "manage branch admin",
    assign_chats: "assign chats",
    submit: "submit",
    choose_chats: "choose chats",
    add_team_link: "add team link",
    company_email: "company email",
    link_title: "link title",
    copy: "copy",
    dashboard: "dashboard",
    branch_admin: "branch admin",
    admin_dashboard: "admin dashboard",
    sub_admin_dashboard: "sub admin dashboard",
    branch_admin_dashboard: "branch admin dashboard",
    sub_admins: "sub admins",
    branches: "branches",
    update_admin_info: "update admin info",
    country_code: "country / region code",
    search_country_code: "search by country / region or code",
    edit: "edit",
    branch_administrator: "branch administrator/s",
    take_picture: "take picture",
    choose_picture: "choose picture",
    update_email: "update email",
    update_password: "update password",
    new_email: "new email",
    confirm_new_email: "confirm new email",
    new_password: "new password",
    confirm_new_password: "confirm new password",
    phone_number_optional: "phone number (optional)",
    email_optional: "email (optional)",
    company_details_updated_successfully:
      "Company details updated successfully",
    add_temp_form: "add temp form",
    temp_form_list: "temp form list",
    choose_admins: "choose admins",
    company_address_details_updated_successfully:
      "Company address details updated successfully",
    teams: "teams",
    chats: "chats",
    app: "app",
    groups: "groups",
    update_chats: "update chats",
    update_groups: "update groups",
    register: "register",
    are_you_sure_wish_delete_chat: "are you sure you wish to delete this chat?",
    are_you_sure_wish_delete_group:
      "are you sure you wish to delete this group?",
    choose_teams: "choose teams",
    update_team_info: "update team info",
    update_team_member: "update team member",
    joined_members: "joined members",
    select_location: "select location",
    work_profile: "work profile",
    appointment_request: "appointment request",
    automated_reply: "automated reply",
    divert: "divert",
    my_messages: "my messages",
    restrict_access: "restrict access",
    groups_shortcut: "groups shortcut",
    branch_details_created_successfully: "branch details created successfully",
    activate: "activate",
    message: "message",
    clear: "clear",
    automated_reply_cannot_be_empty: "automated reply cannot be empty",
    character_exceeded: "character exceeded",
    automated_reply_activated:
      "automated reply has been successfully activated",
    automated_reply_deactivated:
      "automated reply has been successfully deactivated",
    automated_reply_deactivated_confirm:
      "do you wish to deactivate the automated replay message?",
    "2000_characters": "2000 characters",
    internal_visibility: "internal visibility",
    joining_count: "joining count",
    sub_admin_details_created_successfully:
      "sub admin details created successfully",
    are_you_sure_wish_activate_restrict_access:
      "are you sure you wish to activate restrict access?",
    are_you_sure_wish_deactivate_restrict_access:
      "are you sure you wish to deactivate restrict access?",
    restrict_access_successfully_activated:
      "restrict access has been successfully activated",
    restrict_access_successfully_deactivated:
      "restrict access has been successfully deactivated",
    chat_details_created_successfully: "chats details created successfully",
    chat_details_updated_successfully_deactivated:
      "chats details updated successfully",
    group_details_created_successfully: "group details created successfully",
    group_details_updated_successfully_deactivated:
      "group details updated successfully",
    company_verification: "company verification",
    enter_activation_code:
      "enter your company activation code to proceed. if you don't have a code, please contact your administrator",
    add_message: "add message",
    delete_message: "delete message",
    are_you_sure_wish_delete_messages:
      "are you sure you wish to delete the selected messages?",
    no_messages_found: "no messages found",
    delete_my_messages: "delete my messages",
    save: "save",
    update_message: "update message",
    message_created_successfully: "message has been successfully created",
    message_updated_successfully: "message has been successfully updated",
    divert_activated_successfully: "divert has been successfully activated",
    divert_deactivated_successfully: "divert has been successfully deactivated",
    add_groups: "add groups",
    settings: "settings",
    logout: "logout",
    account_settings: "account settings",
    help_support: "help and support",
    help_support_sub: "tutorial videos, help center (FAQs)",
    check_updates: "check updates",
    camera: "camera",
    gallery: "gallery",
    docs: "docs",
    forwarded: "forwarded",
    new_chat: "new chat",
    forward: "forward",
    send: "send",
    forward_to: "forward to",
    select_all: "select all",
    connect: "connect",
    local: "local",
    city: "city",
    national: "national",
    international: "int'l",
    internal_dashboard: "internal dashboard",
    manage_admin_info: "manage admin info",
    choose: "choose",
    choose_branch: `choose ${branchLabelEn}`,
    choose_preferred_branch: `choose preferred ${branchLabelEn}`,
    company_address: "company address",
    choose_members: "choose members",
    group_name: "group name",
    create_group: "create group",
    create_broadcast: "create broadcast",
    broadcast_name: "broadcast name",
    media: "media",
    block: "block",
    mute_notification: "mute notification",
    images: "images",
    audio: "audio",
    video: "video",
    documents: "documents",
    links: "links",
    are_you_sure_to_block_this_user:
      "are you sure you wish to block this user?",
    are_you_sure_to_unblock_this_user:
      "are you sure you wish to unblock this user?",
    for_15_minutes: "for 15 minutes",
    for_1_hour: "for 1 hour",
    for_1_week: "for 1 week",
    until_i_turn_it_back_on: "until i turn it back on",
    un_mute: "un mute",
    delete_selected: "delete selected",
    group_info: "group info",
    clear_chat: "clear chat",
    exit_group: "exit group",
    make_group_admin: "make group admin",
    remove_from_group: "remove from group",
    dismiss_as_admin: "dismiss as admin",
    change_group_info: "change group info",
    add_members: "add members",
    delete_group: "delete group",
    are_you_sure_you_wish_to_delete_this_group:
      "are you sure you wish to delete this group?",
    are_you_sure_you_wish_to_exit_this_group:
      "are you sure you wish to exit this group?",
    exit_and_delete_for_me: "exit and delete for me",
    group_no_longer_a_member:
      "you can't send messages to this group because you're no longer a member",
    are_you_sure_you_wish_to_exit_and_delete_this_group:
      "are you sure you wish to exit and delete this group?",
    are_you_sure_you_wish_to_clear_the_chat:
      "are you sure you wish to clear the chat?",
    you_cant_reply_to_this_conversation: "you can't reply to this conversation",
    social_media_links: "social media links",
    social_media_library: "social media library",
    add_social_media_link: "add social media link",
    email_list: "email list",
    add_new_email_address: "add new email address",
    delete_messages: "delete messages?",
    update_email_address: "update email address",
    email_has_been_successfully_updated: "email has been successfully updated.",
    are_you_sure_you_wish_to_delete_this_email:
      "are you sure you wish to delete this email?",
    email_has_been_successfully_deleted: "email has been successfully deleted.",
    are_you_sure_wish_delete_team:
      "are you sure you wish to delete this team member?",
    are_you_sure_wish_delete_sub_admin:
      "are you sure you wish to delete this sub admin?",
    delete_team_success: "team member deleted successfully.",
    delete_sub_admin_success: "sub admin deleted successfully.",
    sign_in: "sign in",
    new_user: "new user",
    sign_up: "sign up",
    personal_information: "personal information",
    google: "google",
    facebook: "facebook",
    apple: "apple",
    huawei: "huawei",
    next: "next",
    confirm_password: "confirm password",
    city_of_residence: "city of residence (optional)",
    i_accept_communicatr: "i accept communicatr",
    terms_condition: "terms & conditions",
    enter_4_digit:
      "please enter the 4-digit verification code sent to your mobile number",
    didnt_receive_code: "didn't receive code",
    resend: "resend",
    change_email: "change email",
    change_email_phone: "change email / phone number",
    change_phone_number: "change phone number",
    change_verification_details: "change verification details",
    profile_photo: "profile photo",
    do_you_wish_profile_picture: "do you wish to add a profile picture?",
    please_enter_new_email_address: "please enter new email address",
    please_enter_new_mobile_number: "please enter new mobile number",
    hi: "hi",
    you_have_successfully_created_profile:
      "you have successfully created your profile.",
    welcome_to_communicatr: "welcome to communicatr!",
    account_verification: "account verification",
    exit_without_saving: "exit without saving",
    security: "security",
    mobile: "mobile",
    current_password: "current password",
    current_email: "current email",
    current_mobile: "current mobile",
    new_mobile: "new mobile",
    confirm_new_mobile: "confirm new mobile",
    notifications: "notifications",
    chat: "chat",
    follow: "follow",
    unfollow: "unfollow",
    departments: "departments",
    team: "team",
    feedback: "feedback",
    products: "products",
    share: "share",
    call: "call",
    team_members: "team members",
    successfully_joined_group: "successfully joined group",
    downloading: "downloading...",
    successfully_downloaded: "successfully downloaded",
    download_failed_try_again: "download failed, try again!",
    ios: "ios",
    choose_country_code: "choose country code",
    please_enter_new_phone_number: "please enter new phone number",
    please_enter_email_address:
      "please enter the 4-digit verification code sent to your email address",
    agree_terms: "please agree to the terms to continue.",
    password_mismatch: "password mismatch",
    choose_city_of_residence: "choose city of residence",
    would_you_like_to_unfollow_these_branches: `would you like to unfollow these ${branchesLabelEn}?`,
    you_ve_successfully_unfollowed_these_branches: `you've successfully unfollowed these ${branchesLabelEn}`,
    are_you_sure_you_wish_to_delete_this_notice:
      "are you sure you wish to delete this notice",
    notice_deleted_successfully: "notice deleted successfully",
    change_default_branch: `change default ${branchLabelEn}`,
    language_settings: "language settings",
    edit_your_account_settings: "edit your account settings",
    are_you_sure_you_wish_to_unfollow_this_branch: `are you sure you wish to unfollow this ${branchLabelEn}`,
    profile_detail_updated_successfully:
      "profile details updated successfully.",
    are_you_sure_you_wish_to_join_the_group:
      "are you sure you wish to join the group",
    password_updated_successfully: "password updated successfully.",
    email_updated_successfully: "email updated successfully.",
    code_invalid: "code invalid",
    otp_code_invalid: "sorry, the code you entered is invalid.",
    please_enter_verification_cde: "please enter verification code",
    email_mismatch: "email mismatch",
    following: "following",
    filters: "filters",
    dept_chats: "dept chats",
    recover_password: "recover password",
    enter_email_and_send_link_reset_password:
      "enter your email and we'll send you a link to reset your password",
    enter_email_or_mobile_and_send_link_reset_password:
      "enter your email / mobile and we'll send you a code to reset your password",
    reset_password: "reset password",
    email_successfully_send: "email successfully send",
    your_password_changed_successfully:
      "your password has been changed successfully",
    sorry_reset_password_no_longer_valid:
      "sorry, your reset password link is no longer valid",
    continue_with_email: "continue with email",
    privacy_policy: "privacy policy",
    terms_of_use: "terms of use",
    disclaimer: "disclaimer",
    end_user_license_agreement: "end user license agreement",
    edit_account: "edit account",
    are_you_sure_want_to_logout: "are you sure want to logout?",
    menu: "menu",
    group_media: "group media",
    updated_successfully: "updated successfully.",
    follow_groups: "follow groups",
    reset: "reset",
    follow_group_successfully_updated:
      "follow group has been successfully updated",
    appointment: "appointment",
    reservation: "reservation",
    form: "form",
    reservation_request: "reservation request",
    special_request: "special request",
    name: "name",
    date: "date",
    time: "time",
    number_of_people: "number of people",
    subject: "subject",
    appointment_no: "appointment no.",
    reservation_no: "reservation no.",
    seats: "seats",
    request_sent: "request sent",
    request_approved: "request approved",
    request_rejected: "request rejected",
    request_cancelled: "request cancelled",
    submitted: "submitted",
    cancel_appointment_confirm:
      "are you sure you wish to cancel the appointment?",
    cancel_reservation_confirm:
      "are you sure you wish to cancel the reservation?",
    acceptance_received: "acceptance received",
    saved_messages: "saved messages",
    edit_saved_messages: "edit saved messages",
    send_once_off: "send once off",
    update: "update",
    restricted_access: "restricted access",
    invalid_passcode_please_enter_valid_passcode:
      "invalid passcode, please enter valid passcode",
    no_chats: "no active chats",
    deactivate_account: "deactivate account",
    are_you_sure_you_wish_to_deactivate_this_account:
      "are you sure you wish to deactivate this account?",
    deactivate_agreement_text:
      "deactivating your account will ensure you are no longer contactable as your profile will not be visible. \n\nshould any of current contacts attempt to chat to you, they would be informed of your non availability due to your account deactivation/deletion. \n\nyour account will be automatically deleted 30 days after deactivation and returning to communicatr subsequently would require a new sign up. any information will no longer be retrievable. \n\nif, however you log in within the 30 day deactivation period, your deactivation would be cancelled and your account will be resumed",
    select_country: "select country",
    select_state: "select state",
    switch_branch: `switch ${branchLabelEn}`,
    lang_success: "app language successfully changed",
    notices: "notices",
    languages: "languages",
    profile: "profile",
    branch: branchLabelEn,
    near_by: "near by",
    all: "all",
    cancel: "cancel",
    reason_for_leaving: "reason for leaving (optional)",
    reason_cannot_be_empty: "reason cannot be empty",
    delete_account: "delete account",
    delete_agreement_text:
      "delete your account will ensure you are no longer contactable as your profile will not be visible.\n\nshould any of current contacts attempt to chat to you, they would be informed of your non availability due to your account deletion.",
    are_you_sure_you_wish_to_delete_this_account:
      "are you sure you wish to delete this account?",
    deactivated_account_success:
      "your account has now been successfully deactivated",
    deleted_account_success: "your account has now been successfully deleted",
    deactivated_account_success_msg:
      "please remember you may reactivate your account in the next 30 days by logging in. should you not, your account has been permanently deleted. we wish you well and trust your experience on the platform was a positive one.",
    deleted_account_success_msg:
      "please remember that your account has been permanently deleted. we wish you well and hope your experience on the platform has been a positive one.",
    notes: "notes",
    notes_cannot_be_empty: "notes cannot be empty",
    notes_successfully_added: "notes successfully added",
    notes_successfully_deleted: "notes successfully deleted",
    are_you_sure_you_wish_to_delete_this_notes:
      "are you sure you wish to delete this notes",
    feedback_form: "feedback form",
    general_form: "general form",
    general: "general",
    guest_user_phone_email_missing_msg:
      "to enable us to respond to\n you, either your email or\n telephone details need to be \nprovided",
    guest_user_enquiry_success_alert_msg:
      "thank for your enquiry or comment. we will be in touch with you shortly",
    report: "report",
    report_title:
      "communicatr guarantees your confidentiality. no information of yourself will be known to the person being reported.",
    report_note:
      "important: we do not tolerate any unsolicited advertising by any user. advertising is only permitted to followers of a business through our follow and notifications module",
    type_message: "type message",
    report_success: "report has been submitted successfully",
    something_went_wrong: "something went wrong!",
    ok: "ok",
    preview: "preview",
    be_least_8_chars_long: "be at least eight characters long",
    have_leat_1_uppercahse: "have at least one uppercase",
    have_least_1_uppercase: "have at least one lowercase",
    have_least_1_number: "have at least one number",
    have_least_1_special_chat: "have at leat special character",
    password_must_containt: "password must contain:",
    password_not_match_criteria:
      "password does not match the password criteria",
    wish_to_leave: "are you sure you wish to leave?",
    phone_number_is_empty: "phone number is empty",
    continue_as_a: "continue as a",
    guest: "guest",
    end_user_agreement: "end user agreement",
    auto_reply: "auto reply",
    unblock: "unblock",
    auto_reply_enabled: "auto reply enabled",
    message_cannot_be_empty: "message cannot be empty",
    crop_image: "crop image",
    join_with_passcode: "join with passcode",
    invalid_file_type: "invalid file type",
    document: "document",
    send_location: "send location",
    nearby_places: "nearby places",
    send_your_current_location: "send your current location",
    reply: "reply",
    delete: "delete",
    current_location: "current location",
    delete_for_me: "delete for me",
    delete_for_everyone: "delete for everyone",
    text_copied_to_clipboard: "Text copied to clipboard",
    members: "members",
    admin: "admin",
    video_limit_exceeded: "video limit exceeded",
    photo: "photo",
    phone: "phone",
    update_phone_number: "update phone number",
    new_phone_number: "new phone number",
    confirm_new_phone_number: "confirm new phone number",
    phone_number_mismatch: "phone number mismatch",
    phone_updated_successfully: "phone number updated successfully.",
    please_enter_mobile_number:
      "please enter the 4-digit verification code sent to your mobile number",
    confirm: "confirm",
    no: "no",
    yes: "yes",
    divisions: "divisions",
    choose_division: "choose division",
  },
  ar: {
    home: "بيت",
    email: "بريد إلكتروني",
    password: "كلمة المرور",
    login: "تسجيل الدخول",
    forgot_your_password: "نسيت كلمة السر؟",
    company_info: "معلومات الشركة",
    manage_teams: "إدارة الفرق",
    manage_groups: "إدارة المجموعات",
    company_name: "اسم الشركة",
    internal_display_page: "اسم العرض الداخلي",
    landline_number: "رقم الهاتف الثابت",
    mobile_number: "رقم الهاتف المحمول",
    company_website: "موقع الشركة",
    information: "معلومة",
    address: "عنوان",
    title: "عنوان",
    chats: "الدردشات",
    app: "برنامج",
    phone_number: "عنوان",
    assign_admin: "تعيين المشرف",
    country: "البلد / المنطقة",
    state: "ولاية",
    city_town: "المدينة / البلدة",
    suburb: "ضاحية",
    building_name: "اسم المبنى",
    street_name: "اسم الشارع",
    apartment_office_unit_no: "شقة أو مكتب أو وحدة رقم",
    add_team_member: "إضافة عضو الفريق",
    manage_chats: "إدارة الدردشات",
    choose_team: "اختر الفريق",
    add_chats: "إضافة الدردشات",
    group_title: "عنوان المجموعة",
    group_type: "نوع المجموعة",
    open: "يفتح",
    restricted: "مقيد",
    security_passcode: "رمز مرور الأمان",
    assign_team: "assign team",
    default_message: "تعيين فريق",
    type_here_max_200_chars: "اكتب هنا (الحد الأقصى 2000 حرف)",
    please_wait: "انتظر من فضلك...",
    search: "يبحث",
    username: "اسم المستخدم",
    no_results_found: "لم يتم العثور على نتائج",
    format_file_image: "التنسيق - JPEG، png\nدقيقة. الحجم - 50 × 50 بكسل",
    format_file_image2: "الصيغة - jpeg، png، الحد الأدنى للحجم - 50 × 50 بكسل",
    manual_form: "نموذج يدوي",
    create_temp_username_password: "إنشاء اسم مستخدم / كلمة مرور مؤقتة",
    generate_link: "إنشاء رابط",
    add_sub_admin: "إضافة مسؤول فرعي",
    edit_sub_admin: "تعديل المشرف الفرعي",
    change: "يتغير",
    upload: "رفع",
    first_name: "الاسم الأول",
    last_name: "اسم العائلة",
    position: "موضع",
    public_visibility: "الرؤية العامة",
    internal_chat_visibility: "رؤية الدردشة الداخلية",
    manage_sub_admins: "إدارة المسؤولين الفرعيين",
    branch_search: ` بحث ${branchLabelAr}`,
    add_branch: "إضافة فرع",
    choose_city: "اختر المدينة",
    continue: "يكمل",
    update_branch: "فرع التحديث",
    location: "موقع",
    branch_info: `معلومات${branchLabelAr}`,
    manage_branch_admin: "إدارة مدير الفرع",
    assign_chats: "تعيين الدردشات",
    submit: "يُقدِّم",
    choose_chats: "اختر الدردشات",
    add_team_link: "إضافة رابط الفريق",
    company_email: "البريد الإلكتروني للشركة",
    link_title: "عنوان الرابط",
    copy: "ينسخ",
    dashboard: "لوحة القيادة",
    branch_admin: "مشرف الفرع",
    admin_dashboard: "لوحة تحكم المشرف",
    sub_admin_dashboard: "لوحة معلومات المشرف الفرعي",
    branch_admin_dashboard: "لوحة معلومات إدارة الفرع",
    sub_admins: "المشرفين الفرعيين",
    branches: "الفروع",
    update_admin_info: "تحديث معلومات المسؤول",
    country_code: "رمز البلد / المنطقة",
    search_country_code: "البحث حسب البلد أو الرمز",
    edit: "يحرر",
    branch_administrator: "مدير/ مديري الفرع",
    take_picture: "التقط صورة",
    choose_picture: "اختر الصورة",
    update_email: "تحديث البريد الإلكتروني",
    update_password: "تحديث كلمة المرور",
    new_email: "بريد إلكتروني جديد",
    confirm_new_email: "تأكيد البريد الإلكتروني الجديد",
    new_password: "كلمة المرور الجديدة",
    confirm_new_password: "تأكيد كلمة المرور الجديدة",
    phone_number_optional: "رقم الهاتف (اختياري)",
    email_optional: "البريد الإلكتروني (اختياري)",
    company_details_updated_successfully: "تم تحديث تفاصيل الشركة بنجاح",
    add_temp_form: "إضافة نموذج مؤقت",
    temp_form_list: "قائمة النماذج المؤقتة",
    choose_admins: "اختر المسؤولين",
    company_address_details_updated_successfully:
      "تم تحديث تفاصيل عنوان الشركة بنجاح",
    teams: "فرق",
    internal_chat: "الدردشات",
    groups: "مجموعات",
    update_chats: "تحديث الدردشات",
    update_groups: "مجموعات التحديث",
    register: "يسجل",
    are_you_sure_wish_delete_chat: "هل أنت متأكد أنك تريد حذف هذه الدردشة؟",
    are_you_sure_wish_delete_group: "هل أنت متأكد أنك تريد حذف هذه المجموعة؟",
    choose_teams: "اختيار الفرق",
    update_team_info: "تحديث معلومات الفريق",
    update_team_member: "تحديث عضو الفريق",
    joined_members: "انضم أعضاء",
    select_location: "حدد الموقع",
    work_profile: "الملف الشخصي للعمل",
    appointment_request: "طلب موعد",
    automated_reply: "الرد الآلي",
    divert: "تحويل",
    my_messages: "رسائلي",
    restrict_access: "تقييد الوصول",
    groups_shortcut: "اختصار المجموعات",
    branch_details_created_successfully: "تم إنشاء تفاصيل الفرع بنجاح",
    activate: "فعل",
    message: "رسالة",
    clear: "واضح",
    automated_reply_cannot_be_empty: "لا يمكن أن يكون الرد التلقائي فارغًا",
    character_exceeded: "تجاوزت الشخصية",
    automated_reply_activated: "تم تفعيل الرد الآلي بنجاح",
    automated_reply_deactivated: "تم إلغاء تفعيل الرد التلقائي بنجاح",
    automated_reply_deactivated_confirm:
      "هل ترغب في إلغاء تنشيط رسالة الإعادة التلقائية؟",
    "2000_characters": "2000 حرف",
    internal_visibility: "الرؤية الداخلية",
    joining_count: "عدد الانضمام",
    sub_admin_details_created_successfully:
      "تم إنشاء تفاصيل المشرف الفرعي بنجاح",
    are_you_sure_wish_activate_restrict_access:
      "هل أنت متأكد أنك تريد تفعيل تقييد الوصول؟",
    are_you_sure_wish_deactivate_restrict_access:
      "هل أنت متأكد أنك تريد إلغاء تفعيل تقييد الوصول؟",
    restrict_access_successfully_activated: "تم تفعيل تقييد الوصول بنجاح",
    restrict_access_successfully_deactivated:
      "تم إلغاء تفعيل تقييد الوصول بنجاح",
    chat_details_created_successfully: "تم إنشاء تفاصيل المحادثات بنجاح",
    chat_details_updated_successfully_deactivated:
      "تم تحديث تفاصيل المحادثات بنجاح",
    group_details_created_successfully: "تم إنشاء تفاصيل المجموعة بنجاح",
    group_details_updated_successfully_deactivated:
      "تم تحديث تفاصيل المجموعة بنجاح",
    company_verification: "التحقق من الشركة",
    enter_activation_code:
      "أدخل رمز تفعيل شركتك للمتابعة. إذا لم يكن لديك رمز، فيرجى الاتصال بالمسؤول لديك",
    add_message: "إضافة رسالة",
    delete_message: "حذف الرسالة",
    are_you_sure_wish_delete_messages:
      "هل أنت متأكد أنك تريد حذف الرسائل المحددة؟",
    no_messages_found: "لم يتم العثور على رسائل",
    delete_my_messages: "حذف رسائلي",
    save: "يحفظ",
    update_message: "رسالة التحديث",
    message_created_successfully: "تم إنشاء الرسالة بنجاح",
    message_updated_successfully: "تم تحديث الرسالة بنجاح",
    divert_activated_successfully: "تم تفعيل التحويل بنجاح",
    divert_deactivated_successfully: "تم إلغاء تنشيط التحويل بنجاح",
    add_groups: "إضافة مجموعات",
    settings: "إعدادات",
    logout: "تسجيل الخروج",
    account_settings: "إعدادات الحساب",
    help_support: "المساعدة والدعم",
    help_support_sub: "مقاطع فيديو تعليمية، مركز المساعدة (الأسئلة الشائعة)",
    check_updates: "التحقق من التحديثات",
    camera: "آلة تصوير",
    gallery: "معرض",
    docs: "مستندات",
    forwarded: "إعادة توجيه",
    new_chat: "دردشة جديدة",
    forward: "إلى الأمام",
    send: "يرسل",
    forward_to: "إلى الأمام ل",
    select_all: "حدد الكل",
    connect: "يتصل",
    local: "محلي",
    city: "مدينة",
    national: "وطني",
    international: "دولي",
    internal_dashboard: "لوحة القيادة الداخلية",
    manage_admin_info: "إدارة معلومات المسؤول",
    choose: "يختار",
    choose_branch: `اختر ${branchLabelAr}`,
    choose_preferred_branch: `اختر ${branchLabelAr} المفضل`,
    company_address: "عنوان الشركة",
    choose_members: "اختيار أعضاء",
    group_name: "اسم المجموعة",
    create_group: "إنشاء مجموعة",
    create_broadcast: "إنشاء البث",
    broadcast_name: "اسم البث",
    media: "وسائط",
    block: "حاجز",
    mute_notification: "إشعار كتم الصوت",
    images: "الصور",
    audio: "صوتي",
    video: "فيديو",
    documents: "وثائق",
    links: "روابط",
    are_you_sure_to_block_this_user: "هل أنت متأكد أنك تريد حظر هذا المستخدم؟",
    are_you_sure_to_unblock_this_user:
      "هل أنت متأكد أنك تريد إلغاء حظر هذا المستخدم؟",
    for_15_minutes: "لمدة 15 دقيقة",
    for_1_hour: "لمدة ساعة واحدة",
    for_1_week: "لمدة اسبوع",
    until_i_turn_it_back_on: "حتى أقوم بتشغيله مرة أخرى",
    un_mute: "أخرس",
    delete_selected: "حذف المحدد",
    group_info: "معلومات المجموعة",
    clear_chat: "دردشة واضحة",
    exit_group: "مجموعة الخروج",
    make_group_admin: "جعل مدير المجموعة",
    remove_from_group: "إزالة من المجموعة",
    dismiss_as_admin: "استبعاد كمسؤول",
    change_group_info: "تغيير معلومات المجموعة",
    add_members: "إضافة أعضاء",
    delete_group: "حذف المجموعة",
    are_you_sure_you_wish_to_delete_this_group:
      "هل أنت متأكد أنك تريد حذف هذه المجموعة؟",
    are_you_sure_you_wish_to_exit_this_group:
      "هل أنت متأكد أنك تريد الخروج من هذه المجموعة؟",
    exit_and_delete_for_me: "الخروج والحذف بالنسبة لي",
    group_no_longer_a_member:
      "لا يمكنك إرسال رسائل إلى هذه المجموعة لأنك لم تعد عضوًا فيها",
    are_you_sure_you_wish_to_exit_and_delete_this_group:
      "هل أنت متأكد أنك تريد الخروج وحذف هذه المجموعة؟",
    are_you_sure_you_wish_to_clear_the_chat:
      "هل أنت متأكد أنك تريد مسح الدردشة؟",
    you_cant_reply_to_this_conversation: "لا يمكنك الرد على هذه المحادثة",
    social_media_links: "روابط وسائل الاعلام الاجتماعية",
    social_media_library: "مكتبة وسائل الاعلام الاجتماعية",
    add_social_media_link: "إضافة رابط وسائل التواصل الاجتماعي",
    email_list: "قائمة البريد الإلكتروني",
    add_new_email_address: "إضافة عنوان بريد إلكتروني جديد",
    delete_messages: "حذف الرسائل؟",
    update_email_address: "تحديث عنوان البريد الإلكتروني",
    email_has_been_successfully_updated: "تم تحديث البريد الإلكتروني بنجاح.",
    are_you_sure_you_wish_to_delete_this_email:
      "هل أنت متأكد أنك تريد حذف هذا البريد الإلكتروني؟",
    email_has_been_successfully_deleted: "تم حذف البريد الإلكتروني بنجاح.",
    are_you_sure_wish_delete_team:
      "هل أنت متأكد أنك تريد حذف هذا العضو من الفريق؟",
    are_you_sure_wish_delete_sub_admin:
      "هل أنت متأكد أنك تريد حذف هذا المشرف الفرعي؟",
    delete_team_success: "تم حذف عضو الفريق بنجاح.",
    delete_sub_admin_success: "تم حذف المشرف الفرعي بنجاح.",
    sign_in: "تسجيل الدخول",
    new_user: "مستخدم جديد",
    sign_up: "اشتراك",
    personal_information: "معلومات شخصية",
    google: "جوجل",
    facebook: "فيسبوك",
    apple: "تفاحة",
    huawei: "هواوي",
    next: "التالي",
    confirm_password: "تأكيد كلمة المرور",
    city_of_residence: "مدينة الإقامة (اختياري)",
    i_accept_communicatr: "أقبل التواصل",
    terms_condition: "الشروط والأحكام",
    enter_4_digit:
      "يرجى إدخال رمز التحقق المكون من 4 أرقام المرسل إلى رقم هاتفك المحمول",
    didnt_receive_code: "لم يتلق الرمز",
    resend: "إعادة إرسال",
    change_email: "تغيير البريد الإلكتروني",
    change_email_phone: "تغيير البريد الإلكتروني / رقم الهاتف",
    change_phone_number: "تغيير رقم الهاتف",
    change_verification_details: "تغيير تفاصيل التحقق",
    profile_photo: "صورة الملف الشخصي",
    do_you_wish_profile_picture: "هل ترغب بإضافة صورة شخصية؟",
    please_enter_new_email_address:
      "الرجاء إدخال عنوان البريد الإلكتروني الجديد",
    please_enter_new_mobile_number: "الرجاء إدخال رقم الهاتف المحمول الجديد",
    hi: "أهلاً",
    you_have_successfully_created_profile: "لقد قمت بإنشاء ملفك الشخصي بنجاح.",
    welcome_to_communicatr: "مرحباً بكم في communicatr!",
    account_verification: "التحقق من الحساب",
    exit_without_saving: "الخروج دون حفظ",
    security: "حماية",
    mobile: "متحرك",
    current_password: "كلمة المرور الحالية",
    current_email: "البريد الإلكتروني الحالي",
    current_mobile: "المحمول الحالي",
    new_mobile: "المحمول الجديد",
    confirm_new_mobile: "تأكيد المحمول الجديد",
    notifications: "إشعارات",
    chat: "محادثة",
    follow: "يتبع",
    unfollow: "إلغاء المتابعة",
    departments: "الإدارات",
    team: "فريق",
    feedback: "تعليق",
    products: "منتجات",
    share: "يشارك",
    call: "يتصل",
    team_members: "أعضاء الفريق",
    successfully_joined_group: "تم الانضمام للمجموعة بنجاح",
    downloading: "جاري التحميل...",
    successfully_downloaded: "تم التنزيل بنجاح",
    download_failed_try_again: "فشل التنزيل، حاول مرة أخرى!",
    ios: "دائرة الرقابة الداخلية",
    choose_country_code: "اختر رمز البلد",
    please_enter_new_phone_number: "الرجاء إدخال رقم الهاتف الجديد",
    please_enter_email_address:
      "الرجاء إدخال رمز التحقق المكون من 4 أرقام المرسل إلى عنوان بريدك الإلكتروني",
    agree_terms: "الرجاء الموافقة على الشروط للمتابعة.",
    password_mismatch: "عدم تطابق كلمة المرور",
    choose_city_of_residence: "اختر مدينة الإقامة",
    would_you_like_to_unfollow_these_branches: `هل ترغب في إلغاء متابعة هذه ${branchesLabelAr}؟`,
    you_ve_successfully_unfollowed_these_branches: `لقد قمت بإلغاء متابعة هذه ${branchesLabelAr} بنجاح`,
    are_you_sure_you_wish_to_delete_this_notice:
      "هل أنت متأكد أنك تريد حذف هذا الإشعار؟",
    notice_deleted_successfully: "تم حذف الإشعار بنجاح",
    change_default_branch: `تغيير ${branchLabelAr} الافتراضي`,
    language_settings: "إعدادات اللغة",
    edit_your_account_settings: "تعديل إعدادات حسابك",
    are_you_sure_you_wish_to_unfollow_this_branch: `هل أنت متأكد أنك ترغب في إلغاء متابعة هذا ${branchLabelAr}؟`,
    profile_detail_updated_successfully: "تم تحديث تفاصيل الملف الشخصي بنجاح.",
    are_you_sure_you_wish_to_join_the_group:
      "هل أنت متأكد من رغبتك في الانضمام إلى المجموعة؟",
    password_updated_successfully: "تم تحديث كلمة المرور بنجاح.",
    email_updated_successfully: "تم تحديث البريد الإلكتروني بنجاح.",
    code_invalid: "الرمز غير صالح",
    otp_code_invalid: "عذرا، الرمز الذي أدخلته غير صالح.",
    please_enter_verification_cde: "الرجاء إدخال رمز التحقق",
    email_mismatch: "عدم تطابق البريد الإلكتروني",
    following: "التالي",
    filters: "المرشحات",
    dept_chats: "محادثات القسم",
    recover_password: "استعادة كلمة المرور",
    enter_email_and_send_link_reset_password:
      "أدخل بريدك الإلكتروني وسنرسل لك رابطًا لإعادة تعيين كلمة المرور الخاصة بك",
    enter_email_or_mobile_and_send_link_reset_password:
      "أدخل بريدك الإلكتروني / هاتفك المحمول وسنرسل لك رمزًا لإعادة تعيين كلمة المرور الخاصة بك",
    reset_password: "إعادة تعيين كلمة المرور",
    email_successfully_send: "تم إرسال البريد الإلكتروني بنجاح",
    your_password_changed_successfully:
      "لقد تم تغيير كلمة المرور الخاصة بك بنجاح",
    sorry_reset_password_no_longer_valid:
      "عذراً، رابط إعادة تعيين كلمة المرور الخاص بك لم يعد صالحًا",
    continue_with_email: "تواصل مع البريد الإلكتروني",
    privacy_policy: "سياسة الخصوصية",
    terms_of_use: "شروط الاستخدام",
    disclaimer: "تنصل",
    end_user_license_agreement: "اتفاقية ترخيص المستخدم النهائي",
    edit_account: "تحرير الحساب",
    are_you_sure_want_to_logout: "هل أنت متأكد أنك تريد تسجيل الخروج؟",
    menu: "قائمة طعام",
    group_media: "وسائل الإعلام الجماعية",
    updated_successfully: "تم التحديث بنجاح.",
    follow_groups: "متابعة المجموعات",
    reset: "إعادة ضبط",
    follow_group_successfully_updated: "تم تحديث المجموعة المتابعة بنجاح",
    appointment: "ميعاد",
    reservation: "حجز",
    form: "استمارة",
    reservation_request: "طلب الحجز",
    special_request: "طلب خاص",
    name: "اسم",
    date: "تاريخ",
    time: "وقت",
    number_of_people: "عدد الاشخاص",
    subject: "موضوع",
    appointment_no: "رقم الموعد.",
    reservation_no: "رقم الحجز.",
    seats: "مقاعد",
    request_sent: "تم إرسال الطلب",
    request_approved: "تمت الموافقة على الطلب",
    request_rejected: "تم رفض الطلب",
    request_cancelled: "تم إلغاء الطلب",
    submitted: "مُقَدَّم",
    cancel_appointment_confirm: "هل أنت متأكد من رغبتك في إلغاء الموعد؟",
    cancel_reservation_confirm: "هل أنت متأكد من رغبتك في إلغاء الحجز؟",
    acceptance_received: "تلقى القبول",
    saved_messages: "الرسائل المحفوظة",
    edit_saved_messages: "تحرير الرسائل المحفوظة",
    send_once_off: "إرسال مرة واحدة",
    update: "تحديث",
    no_chats: "لا توجد محادثات نشطة",
    restricted_access: "وصول مقيد",
    deactivate_account: "تعطيل الحساب",
    invalid_passcode_please_enter_valid_passcode:
      "رمز المرور غير صالح، الرجاء إدخال رمز المرور صالحًا",
    are_you_sure_you_wish_to_deactivate_this_account:
      "هل أنت متأكد أنك تريد إلغاء تنشيط هذا الحساب؟",
    deactivate_agreement_text:
      "سيؤدي إلغاء تنشيط حسابك إلى ضمان عدم إمكانية الاتصال بك بعد الآن حيث لن يكون ملفك الشخصي مرئيًا. إذا حاول أي من جهات الاتصال الحالية الدردشة معك، فسيتم إبلاغهم بعدم توفرك بسبب إلغاء تنشيط حسابك/حذفه. سيتم حذف حسابك تلقائيًا بعد 30 يومًا من إلغاء التنشيط والعودة إلى التواصل لاحقًا ستتطلب تسجيلًا جديدًا. لن تتمكن من استرداد أي معلومات بعد الآن. ومع ذلك، إذا قمت بتسجيل الدخول خلال فترة إلغاء التنشيط التي تبلغ 30 يومًا، فسيتم إلغاء إلغاء التنشيط الخاص بك وسيتم استئناف حسابك.",
    select_country: "اختر البلد",
    select_state: "حدد الدولة",
    switch_branch: "فرع التبديل",
    lang_success: "تم تغيير لغة التطبيق بنجاح",
    notices: "إشعارات",
    languages: "اللغات",
    profile: "حساب تعريفي",
    branch: branchLabelAr,
    near_by: "بالقرب من",
    all: "الجميع",
    cancel: "يلغي",
    reason_for_leaving: "سبب المغادرة (اختياري)",
    reason_cannot_be_empty: "لا يمكن أن يكون السبب فارغًا",
    delete_account: "حذف الحساب",
    delete_agreement_text:
      "سيؤدي حذف حسابك إلى ضمان عدم إمكانية الاتصال بك بعد الآن حيث لن يكون ملفك الشخصي مرئيًا.\n\nإذا حاول أي من جهات الاتصال الحالية الدردشة معك، فسيتم إعلامهم بعدم توفرك بسبب حذف حسابك.",
    are_you_sure_you_wish_to_delete_this_account:
      "هل أنت متأكد أنك تريد حذف هذا الحساب؟",
    deactivated_account_success: "لقد تم الآن إلغاء تنشيط حسابك بنجاح",
    deleted_account_success: "لقد تم حذف حسابك بنجاح الآن",
    deactivated_account_success_msg:
      "يرجى تذكر أنه يمكنك إعادة تنشيط حسابك خلال الثلاثين يومًا القادمة عن طريق تسجيل الدخول. إذا لم تفعل ذلك، فسيتم حذف حسابك نهائيًا. نتمنى لك التوفيق ونثق في أن تجربتك على المنصة كانت إيجابية.",
    deleted_account_success_msg:
      "يرجى تذكر أن حسابك قد تم حذفه نهائيًا. نتمنى لك التوفيق ونأمل أن تكون تجربتك على المنصة إيجابية.",
    are_you_sure_you_wish_to_delete_this_notes:
      "هل أنت متأكد أنك تريد حذف هذه الملاحظات؟",
    notes: "ملحوظات",
    notes_cannot_be_empty: "لا يمكن أن تكون الملاحظات فارغة",
    notes_successfully_added: "تمت إضافة الملاحظات بنجاح",
    notes_successfully_deleted: "تم حذف الملاحظات بنجاح",
    feedback_form: "نموذج ردود الفعل",
    general_form: "الشكل العام",
    guest_user_enquiry_success_alert_msg:
      "نشكرك على استفسارك أو تعليقك. سنتواصل معك قريبًا",
    guest_user_phone_email_missing_msg:
      "لكي نتمكن من الرد عليك، يتعين عليك تقديم تفاصيل بريدك الإلكتروني أو هاتفك",
    general: "عام",
    report: "تقرير",
    report_title:
      "تضمن شركة communicatr خصوصيتك. لن يعرف الشخص الذي يتم الإبلاغ عنه أي معلومات عنك.",
    report_note:
      "هام: لا نتسامح مع أي إعلانات غير مرغوب فيها من قبل أي مستخدم. يُسمح بالإعلان فقط لمتابعي الشركة من خلال وحدة المتابعة والإشعارات الخاصة بنا",
    type_message: "اكتب الرسالة",
    report_success: "تم تقديم التقرير بنجاح",
    something_went_wrong: "حدث خطأ ما!",
    ok: "نعم",
    preview: "معاينة",
    be_least_8_chars_long: "يجب أن يكون طوله ثمانية أحرف على الأقل",
    have_leat_1_uppercahse: "يجب أن يكون لديك حرف كبير واحد على الأقل",
    have_least_1_uppercase: "لديك حرف صغير واحد على الأقل",
    have_least_1_number: "لديك رقم واحد على الأقل",
    have_least_1_special_chat: "لديها على الأقل طابع خاص",
    password_must_containt: "يجب أن تحتوي كلمة المرور على:",
    password_not_match_criteria: "كلمة المرور لا تتطابق مع معايير كلمة المرور",
    wish_to_leave: "هل أنت متأكد أنك تريد المغادرة؟",
    phone_number_is_empty: "رقم الهاتف فارغ",
    continue_as_a: "الاستمرار ك",
    guest: "ضيف",
    end_user_agreement: "اتفاقية المستخدم النهائي",
    auto_reply: "الرد التلقائي",
    unblock: "إلغاء الحظر",
    auto_reply_enabled: "تم تمكين الرد التلقائي",
    message_cannot_be_empty: "لا يمكن أن تكون الرسالة فارغة",
    crop_image: "صورة المحاصيل",
    join_with_passcode: "الانضمام مع رمز المرور",
    invalid_file_type: "نوع ملف غير صالح",
    document: "وثيقة",
    send_location: "إرسال الموقع",
    nearby_places: "الأماكن القريبة",
    send_your_current_location: "إرسال موقعك الحالي",
    reply: "رد",
    delete: "يمسح",
    current_location: "الموقع الحالي",
    delete_for_me: "حذف بالنسبة لي",
    delete_for_everyone: "حذف للجميع",
    text_copied_to_clipboard: "تم نسخ النص إلى الحافظة",
    members: "أعضاء",
    admin: "مسؤل",
    video_limit_exceeded: "تم تجاوز حد الفيديو",
    photo: "صورة",
    phone: "هاتف",
    update_phone_number: "تحديث رقم الهاتف",
    new_phone_number: "رقم الهاتف الجديد",
    confirm_new_phone_number: "تأكيد رقم الهاتف الجديد",
    phone_number_mismatch: "رقم الهاتف غير متطابق",
    phone_updated_successfully: "تم تحديث رقم الهاتف بنجاح.",
    please_enter_mobile_number:
      "الرجاء إدخال رمز التحقق المكون من 4 أرقام المرسل إلى رقم هاتفك المحمول",
    confirm: "يتأكد",
    no: "لا",
    yes: "نعم",
    divisions: "الانقسامات",
    choose_division: "اختر القسم",
  },
};

export default AppTranslation;
